module.exports = __webpack_public_path__ + "images/f4ee8f9854e3238b547e296ced5e402b-CHETUMAL-WHITE.png";